import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IframeComponent } from './iframe.component';
import { IFrameRoutingService } from './services/routing.service';
import { IFrameMessageService } from './services/message.service';
import { NgxsModule } from '@ngxs/store';
import { IFrameState } from './state/iframe.state';
import { IFrameCommonService } from './services/common.service';
import { MatLegacyProgressSpinnerModule as MatProgressSpinnerModule } from '@angular/material/legacy-progress-spinner';
import { TranslateModule } from "@ngx-translate/core";
import { NgScrollbarModule } from "ngx-scrollbar";

@NgModule({
  imports: [
    CommonModule,
    NgxsModule.forFeature([IFrameState]),
    MatProgressSpinnerModule,
    TranslateModule,
    NgScrollbarModule,
    // CubeGridLoaderComponentModule,
  ],
  declarations: [IframeComponent],
  providers: [IFrameCommonService, IFrameRoutingService, IFrameMessageService],
  exports: [IframeComponent],
})
export class CoreIframeModule {}
